import { Component } from '@angular/core';
import { OmpSectionSettings } from '..';

@Component({
  selector: 'omp-subscription-list-settings',
  templateUrl: './subscription-list-settings.component.html',
  styleUrls: ['../controls/omp-controls.scss'],
})
export class OmpSubscriptionListSettingsComponent extends OmpSectionSettings {
}
